import { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { getActiveCreditTypesService, createCreditRequestService } from "../Credits/Services/credit.Service";
import { CreateCreditRequestDto } from "./Models/create-credit-request.models";

const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');
    @import url('https://cdn.jsdelivr.net/npm/primeicons@6.0.1/primeicons.css');

    .rc-page {
        font-family: 'Plus Jakarta Sans', sans-serif;
        background: #f4f6f9;
        min-height: 100vh;
        padding: 32px 24px 60px;
    }

    .rc-page * { box-sizing: border-box; }

    .rc-root {
        max-width: 760px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        gap: 22px;
    }

    .rc-header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 4px;
    }
    .rc-header-icon {
        width: 52px;
        height: 52px;
        border-radius: 14px;
        background: linear-gradient(140deg, #00A86B 0%, #007a4d 100%);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.4rem;
        flex-shrink: 0;
        box-shadow: 0 6px 18px rgba(0,168,107,0.28);
    }
    .rc-header-icon .pi {
        font-size: 1.4rem;
        color: #fff;
    }
    .rc-header-title {
        font-size: 1.3rem;
        font-weight: 800;
        color: #1a1d23;
        letter-spacing: -0.5px;
        margin: 0;
    }
    .rc-header-sub {
        font-size: 0.8rem;
        color: #9ca3af;
        margin: 3px 0 0;
    }

    .rc-progress {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 14px;
    }
    .rc-progress-step {
        flex: 1;
        height: 4px;
        border-radius: 4px;
        background: #e8eaed;
    }
    .rc-progress-step.done { background: #00A86B; }

    .rc-card {
        background: #ffffff;
        border: 1px solid #e8eaed;
        border-radius: 16px;
        padding: 26px 28px;
    }

    .rc-card-head {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 18px;
    }
    .rc-card-num {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: #f0fdf8;
        color: #00A86B;
        font-size: 0.72rem;
        font-weight: 800;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
    .rc-card-title {
        font-size: 0.92rem;
        font-weight: 700;
        color: #1a1d23;
        margin: 0;
    }
    .rc-card-sub {
        font-size: 0.76rem;
        color: #9ca3af;
        margin: 1px 0 0;
    }

    .rc-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px 18px;
    }
    .rc-grid .rc-full { grid-column: 1 / -1; }

    .rc-field { display: flex; flex-direction: column; gap: 6px; }
    .rc-label {
        font-size: 0.76rem;
        font-weight: 600;
        color: #374151;
    }
    .rc-label .req { color: #ef4444; margin-left: 2px; }

    .rc-error {
        font-size: 0.7rem;
        color: #ef4444;
        margin-top: 2px;
    }

    .rc-root .p-inputtext,
    .rc-root .p-inputnumber-input,
    .rc-root .p-dropdown,
    .rc-root .p-calendar .p-inputtext,
    .rc-page .p-inputtext,
    .rc-page .p-inputnumber-input,
    .rc-page .p-dropdown,
    .rc-page .p-calendar .p-inputtext {
        background: #ffffff !important;
        color: #1a1d23 !important;
        border-radius: 10px !important;
        border: 1px solid #e2e8f0 !important;
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-size: 0.85rem !important;
        padding: 10px 12px !important;
        width: 100%;
    }
    .rc-page .p-inputtext::placeholder {
        color: #94a3b8 !important;
    }
    .rc-page .p-inputtext:enabled:focus,
    .rc-page .p-dropdown:not(.p-disabled).p-focus,
    .rc-page .p-calendar .p-inputtext:enabled:focus {
        border-color: #00A86B !important;
        box-shadow: 0 0 0 1px #00A86B !important;
    }
    .rc-page .p-inputtext.p-invalid,
    .rc-page .p-dropdown.p-invalid,
    .rc-page .p-calendar.p-invalid .p-inputtext {
        border-color: #ef4444 !important;
    }
    .rc-page .p-dropdown-label { padding: 0 !important; color: #1a1d23 !important; }
    .rc-page .p-inputnumber { width: 100%; }
    .rc-page .p-calendar { width: 100%; }

    /* ── Botón del ícono de calendario ── */
    .rc-page .p-calendar .p-datepicker-trigger.p-button,
    .rc-page .p-calendar-w-btn .p-datepicker-trigger {
        background: #ffffff !important;
        border: 1px solid #e2e8f0 !important;
        border-left: none !important;
        color: #64748b !important;
        box-shadow: none !important;
    }
    .rc-page .p-calendar .p-datepicker-trigger.p-button:hover {
        background: #f0fdf8 !important;
        color: #00A86B !important;
    }

    /* ── Paneles flotantes (dropdown y calendario) ──
        Estos paneles se renderizan en un portal fuera de .rc-page,
        por eso necesitan su propio fondo definido a nivel global. */
    .p-dropdown-panel,
    .p-datepicker {
        background: #ffffff !important;
        border: 1px solid #e2e8f0 !important;
        border-radius: 10px !important;
        box-shadow: 0 10px 30px rgba(0,0,0,0.12) !important;
        font-family: 'Plus Jakarta Sans', sans-serif !important;
    }
    .p-dropdown-panel .p-dropdown-items {
        padding: 6px;
    }
    .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
        font-size: 0.85rem !important;
        border-radius: 8px !important;
        padding: 10px 12px !important;
        color: #1a1d23;
    }
    .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
        background: #f0fdf8 !important;
        color: #00A86B !important;
    }
    .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):hover {
        background: #f8fafc !important;
    }
    .p-dropdown-panel .p-dropdown-filter-container .p-inputtext {
        border-radius: 8px !important;
    }

    /* ── Quitar el recuadro gris nativo de los select/dropdown ── */
    .rc-page .p-dropdown,
    .rc-page .p-dropdown:not(.p-disabled).p-focus,
    .rc-page .p-dropdown:not(.p-disabled):hover {
        background: #ffffff !important;
        box-shadow: none !important;
    }
    .rc-page .p-dropdown .p-dropdown-label,
    .rc-page .p-dropdown .p-dropdown-label:focus,
    .rc-page .p-dropdown .p-dropdown-trigger {
        background: transparent !important;
        box-shadow: none !important;
        outline: none !important;
    }
    .rc-page select,
    .rc-page .p-dropdown input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: transparent !important;
        box-shadow: none !important;
    }

    /* ── Calendario ── */
    .p-datepicker {
        padding: 14px !important;
        min-width: 300px;
    }
    .p-datepicker .p-datepicker-header {
        background: #ffffff !important;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2px 2px 14px !important;
        margin-bottom: 8px;
        border-bottom: 1px solid #f1f3f5 !important;
    }
    .p-datepicker .p-datepicker-header .p-datepicker-title {
        display: flex;
        gap: 6px;
        font-size: 0.86rem !important;
        font-weight: 700 !important;
        color: #1a1d23 !important;
    }

    /* ── Botones "Mes" y "Año" dentro del título del header (fix texto invisible) ── */
    .p-datepicker .p-datepicker-header .p-datepicker-title button {
        background: transparent !important;
        border: none !important;
        color: #1a1d23 !important;
        font-size: 0.86rem !important;
        font-weight: 700 !important;
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        cursor: pointer;
        padding: 2px 6px !important;
        border-radius: 6px !important;
    }
    .p-datepicker .p-datepicker-header .p-datepicker-title button:hover {
        background: #f0fdf8 !important;
        color: #00A86B !important;
    }
    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month,
    .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year {
        display: inline-block !important;
    }

    .p-datepicker .p-datepicker-prev,
    .p-datepicker .p-datepicker-next {
        width: 28px !important;
        height: 28px !important;
        border-radius: 8px !important;
        color: #64748b !important;
    }
    .p-datepicker .p-datepicker-prev:hover,
    .p-datepicker .p-datepicker-next:hover {
        background: #f0fdf8 !important;
        color: #00A86B !important;
    }
    .p-datepicker table {
        border-collapse: separate !important;
        border-spacing: 2px !important;
        width: 100% !important;
    }
    .p-datepicker table th {
        font-size: 0.66rem !important;
        font-weight: 700 !important;
        color: #9ca3af !important;
        text-transform: uppercase;
        padding: 6px 0 !important;
    }
    .p-datepicker table td {
        padding: 1px !important;
        text-align: center;
    }
    .p-datepicker table td > span {
        width: 32px !important;
        height: 32px !important;
        border-radius: 8px !important;
        font-size: 0.8rem !important;
        color: #374151 !important;
    }
    .p-datepicker table td > span:hover {
        background: #f0fdf8 !important;
        color: #00A86B !important;
    }
    .p-datepicker table td.p-datepicker-today > span {
        border: 1px solid #00A86B !important;
        color: #00A86B !important;
        font-weight: 700 !important;
        background: transparent !important;
    }
    .p-datepicker table td > span.p-highlight {
        background: #00A86B !important;
        color: #fff !important;
        font-weight: 700 !important;
    }
    .p-datepicker table td.p-datepicker-other-month > span {
        color: #d1d5db !important;
    }

    /* ── Selector de año / mes del calendario (fix del hueco vacío) ── */
    .p-datepicker .p-yearpicker,
    .p-datepicker .p-monthpicker {
        display: grid !important;
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 6px !important;
        padding: 8px 2px 2px !important;
    }
    .p-datepicker .p-yearpicker .p-yearpicker-year,
    .p-datepicker .p-monthpicker .p-monthpicker-month {
        display: flex !important;
        align-items: center;
        justify-content: center;
        padding: 12px 0 !important;
        border-radius: 8px !important;
        font-size: 0.84rem !important;
        color: #374151 !important;
        cursor: pointer;
        transition: background 0.15s, color 0.15s;
    }
    .p-datepicker .p-yearpicker .p-yearpicker-year:hover,
    .p-datepicker .p-monthpicker .p-monthpicker-month:hover {
        background: #f0fdf8 !important;
        color: #00A86B !important;
    }
    .p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight,
    .p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight {
        background: #00A86B !important;
        color: #fff !important;
        font-weight: 700 !important;
    }

    /* ── Toast (alertas) ── */
    .p-toast .p-toast-message {
        border-radius: 12px !important;
        border: 1px solid #e8eaed !important;
        box-shadow: 0 10px 28px rgba(0,0,0,0.12) !important;
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        overflow: hidden;
    }
    .p-toast .p-toast-message-content {
        padding: 14px 16px !important;
        align-items: flex-start !important;
    }
    .p-toast .p-toast-message-icon {
        font-size: 1.15rem !important;
        margin-right: 10px !important;
        margin-top: 1px !important;
    }
    .p-toast .p-toast-summary {
        font-size: 0.84rem !important;
        font-weight: 700 !important;
        color: #1a1d23 !important;
    }
    .p-toast .p-toast-detail {
        font-size: 0.78rem !important;
        color: #6b7280 !important;
        margin-top: 3px !important;
    }
    .p-toast .p-toast-icon-close {
        color: #9ca3af !important;
        width: 22px !important;
        height: 22px !important;
        border-radius: 6px !important;
    }
    .p-toast .p-toast-icon-close:hover {
        background: rgba(0,0,0,0.05) !important;
    }
    .p-toast .p-toast-message-warn {
        background: #fffbeb !important;
        border-left: 4px solid #f59e0b !important;
    }
    .p-toast .p-toast-message-warn .p-toast-message-icon,
    .p-toast .p-toast-message-warn .p-toast-summary {
        color: #b45309 !important;
    }
    .p-toast .p-toast-message-error {
        background: #fef2f2 !important;
        border-left: 4px solid #ef4444 !important;
    }
    .p-toast .p-toast-message-error .p-toast-message-icon,
    .p-toast .p-toast-message-error .p-toast-summary {
        color: #dc2626 !important;
    }
    .p-toast .p-toast-message-success {
        background: #f0fdf8 !important;
        border-left: 4px solid #00A86B !important;
    }
    .p-toast .p-toast-message-success .p-toast-message-icon,
    .p-toast .p-toast-message-success .p-toast-summary {
        color: #047857 !important;
    }

    .rc-summary {
        background: #f0fdf8;
        border: 1px solid #bbf7d0;
        border-radius: 12px;
        padding: 16px 18px;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .rc-summary-row {
        display: flex;
        justify-content: space-between;
        font-size: 0.8rem;
        color: #374151;
    }
    .rc-summary-row b { color: #047857; }

    .rc-actions {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
    }

    .rc-btn-submit.p-button {
        background: #00A86B !important;
        border: none !important;
        border-radius: 12px !important;
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-weight: 600 !important;
        font-size: 0.85rem !important;
        padding: 12px 28px !important;
        box-shadow: 0 4px 16px rgba(0,168,107,0.32) !important;
    }
    .rc-btn-submit.p-button:hover {
        background: #009960 !important;
    }
    .rc-btn-cancel.p-button {
        background: #ffffff !important;
        border: 1px solid #e2e8f0 !important;
        color: #64748b !important;
        border-radius: 12px !important;
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-weight: 600 !important;
        font-size: 0.85rem !important;
        padding: 12px 22px !important;
    }

    /* ── Botón "Simular crédito" ── */
    .rc-sim-trigger {
        display: flex;
        justify-content: flex-end;
        margin-top: 14px;
    }
    .rc-btn-simulate.p-button {
        background: #ffffff !important;
        border: 1px solid #00A86B !important;
        color: #00A86B !important;
        border-radius: 12px !important;
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        font-weight: 600 !important;
        font-size: 0.82rem !important;
        padding: 10px 20px !important;
        box-shadow: none !important;
    }
    .rc-btn-simulate.p-button:enabled:hover {
        background: #f0fdf8 !important;
        color: #00A86B !important;
    }
    .rc-btn-simulate.p-button:disabled {
        opacity: 0.5 !important;
    }

    /* ── Diálogo de simulación ── */
    .p-dialog.rc-sim-dialog {
        border-radius: 16px !important;
        overflow: hidden;
        font-family: 'Plus Jakarta Sans', sans-serif !important;
        box-shadow: 0 20px 48px rgba(0,0,0,0.18) !important;
    }
    .p-dialog.rc-sim-dialog .p-dialog-header {
        background: #ffffff !important;
        padding: 20px 24px 14px !important;
        border-bottom: 1px solid #f1f3f5 !important;
    }
    .p-dialog.rc-sim-dialog .p-dialog-title {
        font-size: 1.02rem !important;
        font-weight: 800 !important;
        color: #1a1d23 !important;
    }
    .p-dialog.rc-sim-dialog .p-dialog-header-icon {
        color: #9ca3af !important;
        border-radius: 8px !important;
        width: 28px !important;
        height: 28px !important;
    }
    .p-dialog.rc-sim-dialog .p-dialog-header-icon:hover {
        background: #f3f4f6 !important;
        color: #374151 !important;
    }
    .p-dialog.rc-sim-dialog .p-dialog-content {
        padding: 18px 24px 24px !important;
        background: #ffffff !important;
    }

    .rc-sim-summary {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        background: #f0fdf8;
        border: 1px solid #bbf7d0;
        border-radius: 12px;
        padding: 14px 16px;
        margin-bottom: 16px;
    }
    .rc-sim-summary > div {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }
    .rc-sim-summary span {
        font-size: 0.66rem;
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 0.3px;
    }
    .rc-sim-summary b {
        font-size: 0.86rem;
        color: #047857;
        font-weight: 800;
    }

    /* ── Tabla de simulación (amortización) ── */
    .rc-sim-table.p-datatable {
        font-family: 'Plus Jakarta Sans', sans-serif !important;
    }
    .rc-sim-table .p-datatable-wrapper {
        border-radius: 10px;
        border: 1px solid #f1f3f5;
        background: #ffffff !important;
    }
    .rc-sim-table .p-datatable-scrollable-header,
    .rc-sim-table .p-datatable-scrollable-body {
        background: #ffffff !important;
    }
    .rc-sim-table .p-datatable-thead > tr > th {
        background: #f8fafc !important;
        color: #374151 !important;
        font-size: 0.7rem !important;
        font-weight: 700 !important;
        text-transform: uppercase;
        letter-spacing: 0.2px;
        border: none !important;
        padding: 10px 12px !important;
    }
    .rc-sim-table .p-datatable-tbody > tr {
        background: #ffffff !important;
    }
    .rc-sim-table .p-datatable-tbody > tr > td {
        background: #ffffff !important;
        font-size: 0.8rem !important;
        color: #374151 !important;
        padding: 9px 12px !important;
        border-bottom: 1px solid #f1f3f5 !important;
    }
    .rc-sim-table .p-datatable-tbody > tr:nth-child(even) {
        background: #fafbfc !important;
    }
    .rc-sim-table .p-datatable-tbody > tr:nth-child(even) > td {
        background: #fafbfc !important;
    }
    .rc-sim-table .p-datatable-tbody > tr:hover,
    .rc-sim-table .p-datatable-tbody > tr:hover > td {
        background: #f0fdf8 !important;
    }
    .rc-sim-table .p-datatable-tbody > tr:last-child > td {
        font-weight: 700 !important;
        color: #1a1d23 !important;
    }

    .rc-ref-item {
    border: 1px solid #e8eaed;
    border-radius: 12px;
    padding: 16px 18px;
    margin-bottom: 14px;
    position: relative;
    }
    .rc-ref-item-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    }
    .rc-ref-item-title {
    font-size: 0.78rem;
    font-weight: 700;
    color: #374151;
    }
    .rc-btn-remove-ref.p-button {
    background: #fff !important;
    border: 1px solid #fecaca !important;
    color: #dc2626 !important;
    border-radius: 8px !important;
    font-size: 0.7rem !important;
    padding: 5px 10px !important;
    box-shadow: none !important;
    }
    .rc-btn-remove-ref.p-button:enabled:hover {
    background: #fef2f2 !important;
    }
    .rc-btn-add-ref.p-button {
    background: #ffffff !important;
    border: 1px dashed #00A86B !important;
    color: #00A86B !important;
    border-radius: 12px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-weight: 600 !important;
    font-size: 0.82rem !important;
    padding: 10px 20px !important;
    box-shadow: none !important;
    width: 100%;
    }
    .rc-btn-add-ref.p-button:enabled:hover {
    background: #f0fdf8 !important;
    }

  @media (max-width: 640px) {
    .rc-page { padding: 20px 14px 40px; }
    .rc-grid { grid-template-columns: 1fr; }
    .rc-card { padding: 20px 18px; }
    .rc-header-title { font-size: 1.1rem; }
    .rc-sim-summary { grid-template-columns: 1fr 1fr; }
  }
`;

interface FormState {
  documentType: string;
  documentNumber: string;
  name: string;
  lastName: string;
  birthDate: Date | null;
  phone: string;
  email: string;
  address: string;
  city: string;
  region: string;
  occupation: string;
  contractType: string;
  employer: string;
  monthlyIncome: number | null;
  creditTypeCode: string;
  requestedAmount: number | null;
  termMonths: number | null;
}

const initialState: FormState = {
  documentType: "CC",
  documentNumber: "",
  name: "",
  lastName: "",
  birthDate: null,
  phone: "",
  email: "",
  address: "",
  city: "",
  region: "",
  occupation: "",
  contractType: "",
  employer: "",
  monthlyIncome: null,
  creditTypeCode: "",
  requestedAmount: null,
  termMonths: null,
};

interface ReferenceForm {
  name: string;
  lastName: string;
  relationship: string;
  phone: string;
  email: string;
}

const emptyReference = (): ReferenceForm => ({
  name: "",
  lastName: "",
  relationship: "",
  phone: "",
  email: "",
});

const documentTypes = [
  { label: "Cédula de ciudadanía", value: "CC" },
  { label: "Cédula de extranjería", value: "CE" },
  { label: "Pasaporte", value: "PAS" },
  { label: "Tarjeta de identidad", value: "TI" },
];

const contractTypes = [
  { label: "Indefinido", value: "Indefinido" },
  { label: "Fijo", value: "Fijo" },
  { label: "Independiente", value: "Independiente" },
  { label: "Prestación de servicios", value: "Prestación de servicios" },
];

function RequestCreditForm(): JSX.Element {
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);
  const idUser = localStorage.getItem("idUser");

  const [form, setForm] = useState<FormState>(initialState);
  const [errors, setErrors] = useState<Partial<Record<keyof FormState, string>>>({});
  const [creditTypes, setCreditTypes] = useState<any[]>([]);
  const [loadingTypes, setLoadingTypes] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [simVisible, setSimVisible] = useState(false);
  const [simRows, setSimRows] = useState<{ n: number; date: Date; quota: number; interest: number; principal: number; balance: number }[] >([]);

  const [references, setReferences] = useState<ReferenceForm[]>([emptyReference(), emptyReference()]);
  const [referenceErrors, setReferenceErrors] = useState<Record<number, Partial<Record<keyof ReferenceForm, string>>>>({});

  useEffect(() => {setLoadingTypes(true); getActiveCreditTypesService().then((res: any) => {setCreditTypes(res?.data ?? res ?? []);})
    .catch((err) => {setCreditTypes([]);})
    .finally(() => setLoadingTypes(false));}, []);

  const selectedType = creditTypes.find((t) => t.code === form.creditTypeCode);

  const setField = (field: keyof FormState, value: any) => {setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const checkAmount = (value: number | null) => {if (!selectedType || value === null) return;
    const min = parseFloat(selectedType.minAmount);
    const max = parseFloat(selectedType.maxAmount);
    if (value < min || value > max) { setErrors((prev) => ({...prev,
        requestedAmount: `El monto debe estar entre ${min.toLocaleString("es-CO")} y ${max.toLocaleString("es-CO")}`,}));
    } else {
      setErrors((prev) => ({ ...prev, requestedAmount: undefined }));
    }
  };

  const checkTerm = (value: number | null) => {
    if (!selectedType || value === null) return;
    if (value < selectedType.minTermMonths || value > selectedType.maxTermMonths) {
      setErrors((prev) => ({
        ...prev,
        termMonths: `El plazo debe estar entre ${selectedType.minTermMonths} y ${selectedType.maxTermMonths} meses`,
      }));
    } else {
      setErrors((prev) => ({ ...prev, termMonths: undefined }));
    }
  };

const setReferenceField = (index: number, field: keyof ReferenceForm, value: string) => { setReferences((prev) => {
    const copy = [...prev];
    copy[index] = { ...copy[index], [field]: value };
    return copy;
});

setReferenceErrors((prev) => {if (!prev[index]?.[field]) return prev;
        const copy = { ...prev, [index]: { ...prev[index], [field]: undefined } };
        return copy;
    });
};

const addReference = () => { setReferences((prev) => [...prev, emptyReference()]);};

const removeReference = (index: number) => {
  setReferences((prev) => prev.filter((_, i) => i !== index));
  setReferenceErrors((prev) => {
    const copy = { ...prev };
    delete copy[index];
    return copy;
  });
};

  const formatCOP = (value: number) =>
    value.toLocaleString("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 });

  const buildSimulation = () => {
    if (!selectedType || form.requestedAmount === null || form.termMonths === null) return;

    const monthlyRate = parseFloat(selectedType.defaultInterestRate) / 100;
    const n = form.termMonths;
    const principal = form.requestedAmount;

    const fixedQuota =
      monthlyRate === 0
        ? principal / n
        : (principal * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -n));

    let balance = principal;
    const rows: { n: number; date: Date; quota: number; interest: number; principal: number; balance: number }[] = [];
    const today = new Date();

    for (let i = 1; i <= n; i++) {
      const interest = balance * monthlyRate;
      let principalPortion = fixedQuota - interest;
      let quota = fixedQuota;

      if (i === n) {
        principalPortion = balance;
        quota = principalPortion + interest;
      }

      balance = Math.max(balance - principalPortion, 0);

      const dueDate = new Date(today.getFullYear(), today.getMonth() + i, today.getDate());

      rows.push({ n: i, date: dueDate, quota, interest, principal: principalPortion, balance });
    }

    setSimRows(rows);
    setSimVisible(true);
  };

  const canSimulate =
    !!selectedType &&
    form.requestedAmount !== null &&
    form.requestedAmount > 0 &&
    form.termMonths !== null &&
    form.termMonths > 0 &&
    !errors.requestedAmount &&
    !errors.termMonths;

  const validate = (): boolean => {const newErrors: Partial<Record<keyof FormState, string>> = {};

    if (!form.documentType || form.documentType.length < 2 || form.documentType.length > 10) {
      newErrors.documentType = "Tipo de documento requerido";
    }
    if (!form.documentNumber || form.documentNumber.length < 5) {
      newErrors.documentNumber = "Número de documento mínimo de 5 caracteres";
    }
    if (!form.name || form.name.length < 2 || form.name.length > 100) {
      newErrors.name = "Nombre requerido (2-100 caracteres)";
    }
    if (!form.lastName || form.lastName.length < 2 || form.lastName.length > 100) {
      newErrors.lastName = "Apellido requerido (2-100 caracteres)";
    }
    if (!form.birthDate) {
      newErrors.birthDate = "La fecha de nacimiento es requerida";
    }
    if (!form.phone || form.phone.length > 20) {
      newErrors.phone = "Teléfono requerido (máx 20 caracteres)";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!form.email || !emailRegex.test(form.email) || form.email.length > 100) {
      newErrors.email = "Correo electrónico no válido";
    }
    if (!form.address || form.address.length > 200) {
      newErrors.address = "Dirección requerida (máx 200 caracteres)";
    }
    if (!form.city || form.city.length > 100) {
      newErrors.city = "Ciudad requerida";
    }
    if (!form.region || form.region.length > 100) {
      newErrors.region = "Región requerida";
    }
    if (!form.occupation || form.occupation.length > 100) {
      newErrors.occupation = "Ocupación requerida";
    }
    if (!form.contractType || form.contractType.length > 100) {
      newErrors.contractType = "Tipo de contrato requerido";
    }
    if (!form.employer || form.employer.length > 100) {
      newErrors.employer = "Nombre de la empresa requerido";
    }
    if (form.monthlyIncome === null || form.monthlyIncome <= 0) {
      newErrors.monthlyIncome = "Los ingresos mensuales deben ser positivos";
    }
    if (!form.creditTypeCode) {
      newErrors.creditTypeCode = "Selecciona un tipo de crédito";
    }
    if (form.requestedAmount === null || form.requestedAmount <= 0) {
      newErrors.requestedAmount = "El monto solicitado debe ser positivo";
    } else if (selectedType) {
      const min = parseFloat(selectedType.minAmount);
      const max = parseFloat(selectedType.maxAmount);
      if (form.requestedAmount < min || form.requestedAmount > max) {
        newErrors.requestedAmount = `El monto debe estar entre ${min.toLocaleString("es-CO")} y ${max.toLocaleString("es-CO")}`;
      }
    }
    if (form.termMonths === null || form.termMonths < 1 || form.termMonths > 360) {
      newErrors.termMonths = "El plazo debe estar entre 1 y 360 meses";
    } else if (selectedType) {
      if (form.termMonths < selectedType.minTermMonths || form.termMonths > selectedType.maxTermMonths) {
        newErrors.termMonths = `El plazo debe estar entre ${selectedType.minTermMonths} y ${selectedType.maxTermMonths} meses`;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;

    const newReferenceErrors: Record<number, Partial<Record<keyof ReferenceForm, string>>> = {};

    if (references.length < 2) {
    toast.current?.show({
        severity: "warn",
        summary: "Referencias insuficientes",
        detail: "Debes agregar al menos 2 referencias personales",
        life: 3500,
    });
    }

    references.forEach((ref, index) => { const refErrs: Partial<Record<keyof ReferenceForm, string>> = {};
        if (!ref.name || ref.name.length < 2) refErrs.name = "Nombre requerido";
        if (!ref.lastName || ref.lastName.length < 2) refErrs.lastName = "Apellido requerido";
        if (!ref.relationship) refErrs.relationship = "Parentesco requerido";
        if (!ref.phone || ref.phone.length < 7) refErrs.phone = "Teléfono requerido";
        if (Object.keys(refErrs).length > 0) newReferenceErrors[index] = refErrs;
    });

    setReferenceErrors(newReferenceErrors);

    const referencesValid = references.length >= 2 && Object.keys(newReferenceErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      toast.current?.show({
        severity: "warn",
        summary: "Formulario incompleto",
        detail: "Revisa los campos marcados en rojo",
        life: 3500,
      });
      return;
    }

    setSubmitting(true);
    try {
      const payload: CreateCreditRequestDto = {
        documentType: form.documentType,
        documentNumber: form.documentNumber,
        name: form.name,
        lastName: form.lastName,
        birthDate: form.birthDate!,
        phone: form.phone,
        email: form.email,
        address: form.address,
        city: form.city,
        region: form.region,
        occupation: form.occupation,
        contractType: form.contractType,
        employer: form.employer,
        monthlyIncome: form.monthlyIncome!,
        creditTypeCode: form.creditTypeCode,
        requestedAmount: form.requestedAmount!,
        termMonths: form.termMonths!,
        personalReferences: references.map((r) => ({
            name: r.name,
            lastName: r.lastName,
            relationship: r.relationship,
            phone: r.phone,
            email: r.email || undefined,
        })),
      };

      const response = await createCreditRequestService(idUser ? +idUser : 0, payload);

      if (response?.statusCode && response.statusCode >= 300) {
        toast.current?.show({
          severity: "error",
          summary: "No se pudo enviar la solicitud",
          detail: response.message ?? "Intenta nuevamente",
          life: 4000,
        });
        return;
      }

      toast.current?.show({
        severity: "success",
        summary: "¡Solicitud enviada!",
        detail: "Tu solicitud de crédito fue registrada correctamente",
        life: 3000,
      });

      setTimeout(() => navigate("/inicio"), 1200);
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message ?? "No se pudo enviar la solicitud",
        life: 4000,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="rc-page">
      <style>{styles}</style>
      <Toast ref={toast} />
      <div className="rc-root">

        {/* ── Header ── */}
        <div className="rc-header">
          <div className="rc-header-icon">
            <i className="pi pi-file-edit" />
          </div>
          <div>
            <h1 className="rc-header-title">Solicitud de crédito en curso</h1>
            <p className="rc-header-sub">Completa la información para enviar tu solicitud</p>
          </div>
        </div>

        {/* ── Tipo de crédito ── */}
        <div className="rc-card">
          <div className="rc-card-head">
            <span className="rc-card-num">1</span>
            <div>
              <h3 className="rc-card-title">Tipo de crédito</h3>
              <p className="rc-card-sub">Selecciona el crédito que deseas solicitar</p>
            </div>
          </div>

          <div className="rc-grid">
            <div className="rc-field rc-full">
              <label className="rc-label">Tipo de crédito<span className="req">*</span></label>
              <Dropdown
                value={form.creditTypeCode}
                options={creditTypes.map((t) => ({ label: t.name, value: t.code }))}
                onChange={(e) => setField("creditTypeCode", e.value)}
                placeholder={loadingTypes ? "Cargando tipos de crédito..." : "Selecciona un tipo de crédito"}
                disabled={loadingTypes}
                emptyMessage="No hay tipos de crédito disponibles"
                className={errors.creditTypeCode ? "p-invalid" : ""}
              />
              {errors.creditTypeCode && <span className="rc-error">{errors.creditTypeCode}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Monto solicitado<span className="req">*</span></label>
              <InputNumber
                value={form.requestedAmount}
                onValueChange={(e) => setField("requestedAmount", e.value ?? null)}
                onBlur={() => checkAmount(form.requestedAmount)}
                mode="currency"
                currency="COP"
                locale="es-CO"
                maxFractionDigits={0}
                className={errors.requestedAmount ? "p-invalid" : ""}
              />
              {errors.requestedAmount && <span className="rc-error">{errors.requestedAmount}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Plazo (meses)<span className="req">*</span></label>
              <InputNumber
                value={form.termMonths}
                onValueChange={(e) => setField("termMonths", e.value ?? null)}
                onBlur={() => checkTerm(form.termMonths)}
                className={errors.termMonths ? "p-invalid" : ""}
              />
              {errors.termMonths && <span className="rc-error">{errors.termMonths}</span>}
            </div>
          </div>

          {selectedType && (
            <div className="rc-summary" style={{ marginTop: 16 }}>
              <div className="rc-summary-row">
                <span>Tasa de interés</span>
                <b>{selectedType.defaultInterestRate}%</b>
              </div>
              <div className="rc-summary-row">
                <span>Monto permitido</span>
                <b>
                  {parseFloat(selectedType.minAmount).toLocaleString("es-CO")} - {parseFloat(selectedType.maxAmount).toLocaleString("es-CO")}
                </b>
              </div>
              <div className="rc-summary-row">
                <span>Plazo permitido</span>
                <b>{selectedType.minTermMonths} - {selectedType.maxTermMonths} meses</b>
              </div>
            </div>
          )}

          <div className="rc-sim-trigger">
            <Button
              type="button"
              label="Simular crédito"
              icon="pi pi-calculator"
              className="rc-btn-simulate"
              onClick={buildSimulation}
              disabled={!canSimulate}
            />
          </div>
        </div>

        {/* ── Datos personales ── */}
        <div className="rc-card">
          <div className="rc-card-head">
            <span className="rc-card-num">2</span>
            <div>
              <h3 className="rc-card-title">Datos personales</h3>
              <p className="rc-card-sub">Información del solicitante</p>
            </div>
          </div>

          <div className="rc-grid">
            <div className="rc-field">
              <label className="rc-label">Tipo de documento<span className="req">*</span></label>
              <Dropdown
                value={form.documentType}
                options={documentTypes}
                onChange={(e) => setField("documentType", e.value)}
                className={errors.documentType ? "p-invalid" : ""}
              />
              {errors.documentType && <span className="rc-error">{errors.documentType}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Número de documento<span className="req">*</span></label>
              <InputText
                value={form.documentNumber}
                onChange={(e) => setField("documentNumber", e.target.value)}
                className={errors.documentNumber ? "p-invalid" : ""}
              />
              {errors.documentNumber && <span className="rc-error">{errors.documentNumber}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Nombres<span className="req">*</span></label>
              <InputText
                value={form.name}
                onChange={(e) => setField("name", e.target.value)}
                className={errors.name ? "p-invalid" : ""}
              />
              {errors.name && <span className="rc-error">{errors.name}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Apellidos<span className="req">*</span></label>
              <InputText
                value={form.lastName}
                onChange={(e) => setField("lastName", e.target.value)}
                className={errors.lastName ? "p-invalid" : ""}
              />
              {errors.lastName && <span className="rc-error">{errors.lastName}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Fecha de nacimiento<span className="req">*</span></label>
              <Calendar
                value={form.birthDate}
                onChange={(e) => setField("birthDate", e.value as Date)}
                dateFormat="dd/mm/yy"
                showIcon
                maxDate={new Date()}
                className={errors.birthDate ? "p-invalid" : ""}
              />
              {errors.birthDate && <span className="rc-error">{errors.birthDate}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Teléfono<span className="req">*</span></label>
              <InputText
                value={form.phone}
                onChange={(e) => setField("phone", e.target.value)}
                className={errors.phone ? "p-invalid" : ""}
              />
              {errors.phone && <span className="rc-error">{errors.phone}</span>}
            </div>

            <div className="rc-field rc-full">
              <label className="rc-label">Correo electrónico<span className="req">*</span></label>
              <InputText
                value={form.email}
                onChange={(e) => setField("email", e.target.value)}
                className={errors.email ? "p-invalid" : ""}
              />
              {errors.email && <span className="rc-error">{errors.email}</span>}
            </div>

            <div className="rc-field rc-full">
              <label className="rc-label">Dirección<span className="req">*</span></label>
              <InputText
                value={form.address}
                onChange={(e) => setField("address", e.target.value)}
                className={errors.address ? "p-invalid" : ""}
              />
              {errors.address && <span className="rc-error">{errors.address}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Ciudad<span className="req">*</span></label>
              <InputText
                value={form.city}
                onChange={(e) => setField("city", e.target.value)}
                className={errors.city ? "p-invalid" : ""}
              />
              {errors.city && <span className="rc-error">{errors.city}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Región / Departamento<span className="req">*</span></label>
              <InputText
                value={form.region}
                onChange={(e) => setField("region", e.target.value)}
                className={errors.region ? "p-invalid" : ""}
              />
              {errors.region && <span className="rc-error">{errors.region}</span>}
            </div>
          </div>
        </div>

        {/* ── Información laboral ── */}
        <div className="rc-card">
          <div className="rc-card-head">
            <span className="rc-card-num">3</span>
            <div>
              <h3 className="rc-card-title">Información laboral</h3>
              <p className="rc-card-sub">Datos de tu situación financiera actual</p>
            </div>
          </div>

          <div className="rc-grid">
            <div className="rc-field">
              <label className="rc-label">Ocupación<span className="req">*</span></label>
              <InputText
                value={form.occupation}
                onChange={(e) => setField("occupation", e.target.value)}
                className={errors.occupation ? "p-invalid" : ""}
              />
              {errors.occupation && <span className="rc-error">{errors.occupation}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Tipo de contrato<span className="req">*</span></label>
              <Dropdown
                value={form.contractType}
                options={contractTypes}
                onChange={(e) => setField("contractType", e.value)}
                placeholder="Selecciona"
                className={errors.contractType ? "p-invalid" : ""}
              />
              {errors.contractType && <span className="rc-error">{errors.contractType}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Empresa donde labora<span className="req">*</span></label>
              <InputText
                value={form.employer}
                onChange={(e) => setField("employer", e.target.value)}
                className={errors.employer ? "p-invalid" : ""}
              />
              {errors.employer && <span className="rc-error">{errors.employer}</span>}
            </div>

            <div className="rc-field">
              <label className="rc-label">Ingresos mensuales<span className="req">*</span></label>
              <InputNumber
                value={form.monthlyIncome}
                onValueChange={(e) => setField("monthlyIncome", e.value ?? null)}
                mode="currency"
                currency="COP"
                locale="es-CO"
                maxFractionDigits={0}
                className={errors.monthlyIncome ? "p-invalid" : ""}
              />
              {errors.monthlyIncome && <span className="rc-error">{errors.monthlyIncome}</span>}
            </div>
          </div>
        </div>

        {/* ── Referencias personales ── */}
        <div className="rc-card">
        <div className="rc-card-head">
            <span className="rc-card-num">4</span>
            <div>
            <h3 className="rc-card-title">Referencias personales</h3>
            <p className="rc-card-sub">Agrega al menos 2 personas que puedan dar referencia de ti</p>
            </div>
        </div>

        {references.map((ref, index) => (
            <div className="rc-ref-item" key={index}>
            <div className="rc-ref-item-head">
                <span className="rc-ref-item-title">Referencia {index + 1}</span>
                {references.length > 2 && (
                <Button
                    type="button"
                    label="Quitar"
                    icon="pi pi-trash"
                    className="rc-btn-remove-ref"
                    onClick={() => removeReference(index)}
                />
                )}
            </div>

            <div className="rc-grid">
                <div className="rc-field">
                <label className="rc-label">Nombres<span className="req">*</span></label>
                <InputText
                    value={ref.name}
                    onChange={(e) => setReferenceField(index, "name", e.target.value)}
                    className={referenceErrors[index]?.name ? "p-invalid" : ""}
                />
                {referenceErrors[index]?.name && <span className="rc-error">{referenceErrors[index]?.name}</span>}
                </div>

                <div className="rc-field">
                <label className="rc-label">Apellidos<span className="req">*</span></label>
                <InputText
                    value={ref.lastName}
                    onChange={(e) => setReferenceField(index, "lastName", e.target.value)}
                    className={referenceErrors[index]?.lastName ? "p-invalid" : ""}
                />
                {referenceErrors[index]?.lastName && <span className="rc-error">{referenceErrors[index]?.lastName}</span>}
                </div>

                <div className="rc-field">
                <label className="rc-label">Parentesco<span className="req">*</span></label>
                <InputText
                    value={ref.relationship}
                    onChange={(e) => setReferenceField(index, "relationship", e.target.value)}
                    placeholder="Ej: Familiar, Amigo, Compañero"
                    className={referenceErrors[index]?.relationship ? "p-invalid" : ""}
                />
                {referenceErrors[index]?.relationship && <span className="rc-error">{referenceErrors[index]?.relationship}</span>}
                </div>

                <div className="rc-field">
                <label className="rc-label">Teléfono<span className="req">*</span></label>
                <InputText
                    value={ref.phone}
                    onChange={(e) => setReferenceField(index, "phone", e.target.value)}
                    className={referenceErrors[index]?.phone ? "p-invalid" : ""}
                />
                {referenceErrors[index]?.phone && <span className="rc-error">{referenceErrors[index]?.phone}</span>}
                </div>

                <div className="rc-field rc-full">
                <label className="rc-label">Correo electrónico</label>
                <InputText
                    value={ref.email}
                    onChange={(e) => setReferenceField(index, "email", e.target.value)}
                />
                </div>
            </div>
            </div>
        ))}

        <Button
            type="button"
            label="Agregar otra referencia"
            icon="pi pi-plus"
            className="rc-btn-add-ref"
            onClick={addReference}
        />
        </div>

        <div className="rc-actions">
          <Button
            label="Cancelar"
            className="rc-btn-cancel"
            onClick={() => navigate("/inicio")}
            disabled={submitting}
          />
          <Button
            label={submitting ? "Enviando..." : "Enviar solicitud"}
            icon="pi pi-check"
            iconPos="right"
            className="rc-btn-submit"
            onClick={handleSubmit}
            disabled={submitting}
          />
        </div>
      </div>

      {/* ── Popup de simulación de crédito ── */}
      <Dialog
        header="Simulación de crédito"
        visible={simVisible}
        onHide={() => setSimVisible(false)}
        className="rc-sim-dialog"
        style={{ width: "680px", maxWidth: "95vw" }}
        modal
      >
        {selectedType && (
          <div className="rc-sim-summary">
            <div>
              <span>Monto</span>
              <b>{formatCOP(form.requestedAmount ?? 0)}</b>
            </div>
            <div>
              <span>Plazo</span>
              <b>{form.termMonths} meses</b>
            </div>
            <div>
              <span>Tasa mensual</span>
              <b>{selectedType.defaultInterestRate}%</b>
            </div>
            <div>
              <span>Cuota mensual</span>
              <b>{formatCOP(simRows[0]?.quota ?? 0)}</b>
            </div>
          </div>
        )}

        <DataTable
          value={simRows}
          className="rc-sim-table"
          scrollable
          scrollHeight="360px"
          size="small"
        >
          <Column field="n" header="Cuota" style={{ width: "64px" }} />
          <Column
            header="Fecha"
            body={(row) => row.date.toLocaleDateString("es-CO", { day: "2-digit", month: "2-digit", year: "numeric" })}
          />
          <Column header="Valor cuota" body={(row) => formatCOP(row.quota)} />
          <Column header="Interés" body={(row) => formatCOP(row.interest)} />
          <Column header="Abono a capital" body={(row) => formatCOP(row.principal)} />
          <Column header="Saldo" body={(row) => formatCOP(row.balance)} />
        </DataTable>
      </Dialog>
    </div>
  );
}

export default RequestCreditForm;